export const hasPermissionsAPISupport = () => {
	return 'permissions' in navigator;
};

export const hasMediaDeviceAPISupport = () => {
	return 'mediaDevices' in navigator;
};

export default { hasPermissionsAPISupport, hasMediaDeviceAPISupport };
